var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3276 34.1442C31.2597 28.6698 31.1524 22.7661 29.0592 17.3454C26.8588 17.2917 24.6583 17.8821 22.6725 18.9018L21.5991 19.4385C21.6527 19.5995 21.7601 19.8142 21.8674 19.9216C24.2289 24.8592 24.5509 30.441 22.6725 35.647C21.3844 39.2966 21.7064 43.2682 23.4239 46.7031L23.9606 47.7765C24.1216 47.7228 24.3362 47.6155 24.4436 47.5081C25.839 46.8641 27.3418 46.3274 28.8982 45.9517C27.8248 42.1948 27.9322 38.0085 29.3276 34.1442Z",
    fill: "#22C55E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5449 46.8639C38.6665 42.3019 38.5054 37.2033 40.1692 32.5339C41.672 28.2403 41.9403 23.6783 40.9743 19.3847C38.5591 19.4384 36.1976 19.1164 33.8361 18.2576C35.4999 23.893 35.3389 29.9578 33.3531 35.5931C32.1723 38.8134 32.1724 42.3556 33.2458 45.5758C35.5536 45.5222 37.9151 45.9515 40.2229 46.7566C40.2229 46.7566 40.3839 46.8103 40.5449 46.8639Z",
    fill: "#22C55E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e688aa6394753baa47700ea9e303ae21.svg";
export { ForwardRef as ReactComponent };